/* eslint-disable class-methods-use-this */

class BaseAuthStrategy {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty-function, no-useless-constructor
  constructor(options) {}

  /**
   * This method is called before the request is sent.
   * You can use this method to add authorization header to the request.
   */
  requestInterceptor(config) {
    return Promise.resolve(config);
  }

  /**
   * This method is called if there is an error during the request.
   * You can throw an error, or return a promise.
   */
  onResponseError(axios, error) {
    throw error;
  }
}
var BaseAuthStrategy$1 = BaseAuthStrategy;

export { BaseAuthStrategy$1 as default };
//# sourceMappingURL=BaseAuthStrategy.js.map
